/**
 * 设置模块的接口
 */
import http from '@/service/http'
import {ROOT_SIMULATOR} from './urlConfig'

//获取用户键位绑定
export const getUserKeybinding = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/user/keybinding/getUserKeybinding',params)
}

//设置用户键位绑定
export const setUserKeybinding = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/user/keybinding/setUserKeybinding',params)
}

//设置用户键位绑定
export const getKeyTypeList = (params:object)=>{
    return http.get(ROOT_SIMULATOR+'/api/user/keybinding/keyTypeList',params)
}

//获取用户灵敏度设置
export const getUserSensibility = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/user/keybinding/getUserStickSensitivitySetting',params)
}

//保存用户灵敏度设置
export const setUserSensibility = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/user/keybinding/saveUserStickSensitivitySetting',params)
}

//获取用户声音设置
export const getUserSoundsSetting = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/user/getUserSoundsSetting',params)
}

//保存用户声音设置
export const saveUserSoundsSetting = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/user/saveUserSoundsSetting',params)
}

//获取用户分辨率设置
export const getUserResolutionSetting = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/user/getUserResolutionSetting',params)
}

//保存用户分辨率设置
export const saveUserResolutionSetting = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/user/saveUserResolutionSetting',params)
}

//获取用户键盘键位绑定
export const getUserKeyboardKeybinding = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/user/keybinding/getUserKeyboardKeyMapping',params)
}

//保存用户键盘键位绑定
export const saveUserKeyboardKeybinding = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/user/keybinding/setUserKeyboardKeyMapping',params)
}

// 保存用户上次使用手柄
export const saveUserJoystickSpecification = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/user/saveUserJoystickSpecification',params)
}

// 获取用户上次使用手柄
export const getUserJoystickSpecification = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/user/getUserJoystickSpecification',params)
}

